import { Text, View } from '@react-pdf/renderer';
import { useTranslation } from 'react-i18next';
import colors from '../../../styles/_variables.module.scss';
import { PaymentResponse, TravelPaymentSuccess } from '../../../types/paymentResult.types';
import { formatCustomDate, styles } from '../../../utils/receipt.helper';
import CommonReceiptData from '../../CommonReceiptData';

interface TravelReceiptDetailProps {
  paymentSuccess: PaymentResponse | null;
}

function TravelReceiptDetail({ paymentSuccess }: TravelReceiptDetailProps) {
  const { t } = useTranslation();
  const data = paymentSuccess?.data as TravelPaymentSuccess;

  return (
    <>
      <View style={styles.detailHeader}>
        <Text style={styles.headerTitle}>{t('receipt-detail.title')}</Text>
        <Text style={styles.headerSubTitle}>{data?.agency?.toUpperCase()}</Text>
        <Text style={styles.text}>{t('verticals.travel_agency.receipt-detail.subtitle')}</Text>
        <View style={styles.gap} />
        <Text style={styles.text}>{data?.paymentId}</Text>
        <Text style={styles.text}>{data.booking}</Text>
        <Text style={{ color: colors.placeholderGrey, fontSize: 12 }}>
          {formatCustomDate(data?.date || '')}
        </Text>
      </View>
      <View style={styles.gap} />
      <CommonReceiptData
        data={data}
        children={<View style={styles.gap} />}
        country={paymentSuccess?.country}
      />
    </>
  );
}

export default TravelReceiptDetail;
